import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;
const endpoint = "/api/kokam/aprobados";

/**
 * Subir Excel de aprobados
 * @param {File} file
 */
export const subirExcelAprobados = async (file) => {
  try {
    const formData = new FormData();
    formData.append("archivo", file);

    const response = await axios.post(
      `${baseUrl}${endpoint}/upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;

  } catch (error) {
    console.error("Error subiendo Excel de aprobados:", error);
    throw error;
  }
};